import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'report-detailed-pullup',
})

export default class ReportDetailedPullup extends Vue {

    // ------------------------------------------------------------
    // Properties

    @Prop()
    private reportData: any;

    @Prop()
    private reportFields: any;



}
